import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import ListCamps from "./List";
import { CAMPS, StudentServicePath } from "utils/constants";
import EditCamps from "./Edit";
import CreateCamps from "./Create";
import ShowCamps from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <SportsSoccerIcon />,
  name: StudentServicePath + CAMPS,
  title: "Спортни лагери",
  list: <ListCamps />,
  create: <CreateCamps />,
  createPermission: permissions.canCreateCamps,
  edit: <EditCamps />,
  editPermission: permissions.canUpdateCamps,
  show: <ShowCamps />,
  showPermission: permissions.canPreviewCamps,
  permission: permissions.canPreviewCamps,
};
